module.exports = __webpack_public_path__ + "img/flood_10.4bca8362.svg";